import React from 'react';
import classnames from 'classnames';
import { useField } from 'formik';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import CharCounter from '../CharCounter';
import Asterisk from '../Asterisk/index';
import { LabelLarge } from '@styled';
import colors from '@general/colors';

const TextareaStyled = styled.textarea`
    border: 1px solid ${colors.lightGray};
`;

const Textarea = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const { id, name, required, charCount } = props;

    // remove so it isn't passed to textarea
    // eslint-disable-next-line react/destructuring-assignment
    delete props.charCount;
    const hasError = meta.touched && meta.error;
    const groupClasses = classnames('form-group', { 'has-danger': hasError });
    const inputClasses = classnames('form-control', 'p-3', { 'form-control-danger': hasError });

    return (
        <div className={groupClasses}>
            <label htmlFor={id || name}>
                <LabelLarge>
                    {label} {required && <Asterisk />}
                </LabelLarge>
            </label>

            <TextareaStyled className={inputClasses} {...field} {...props} />
            {hasError ? <div className="error-msg">{meta.error}</div> : null}
            {charCount && <CharCounter count={field?.value?.length} max={charCount} />}
        </div>
    );
};

Textarea.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    charCount: PropTypes.number,
    required: PropTypes.bool,
};

export default Textarea;
